export default __webpack_public_path__ + "static/media/action.435c1f0b.svg";